import { UIHeading1, UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { CONTENT } from './content';
import * as styles from './styles.css';

export const AdvantagesAgent: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1 color="text-inverted-default">Когда пригодится онлайн-договор</UIHeading1>
      </div>
      <div className={styles['items']}>
        {CONTENT.map((item, i) => {
          return (
            <div key={i} className={styles['item']}>
              <img src={item.imgSrc} width={item.imgWidth} height={item.imgHeight} />
              <div className={styles['item-title']}>
                <UIHeading2 color="text-inverted-default">{item.title}</UIHeading2>
              </div>
              <UIText2 color="text-inverted-default">{item.text}</UIText2>
            </div>
          );
        })}
      </div>
    </div>
  );
};

AdvantagesAgent.displayName = 'AdvantagesAgent';
